import axios from 'axios';


//https://localhost:44301
const resolveBaseURL = () => {
  try {
    const { hostname, origin } = window.location;
    if (hostname.includes('localhost')) {
      return 'https://adminrotary.codiatest.com/';
    }
    // fallback to same-origin for hosted environments
    return origin;
  } catch (e) {
    return 'https://adminrotary.codiatest.com/';
  }
};

export const httpClient = axios.create({
  baseURL: resolveBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain',
  },
  withCredentials: true,
});

httpClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth.token');
  if (token) {
    // Attach Bearer token
    // Some backends accept only Authorization; adjust if needed
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Central place to handle 401/403 in the future
    return Promise.reject(error);
  }
);

export default httpClient;


